// extracted by mini-css-extract-plugin
export var contentBody = "_70-9";
export var headerImage = "_70-2";
export var imageButton = "_70-7";
export var imageButtonIcon = "_70-8";
export var imageHeader = "_70-4";
export var imageHeaderText = "_70-5";
export var imageOverlay = "_70-3";
export var imageTitle = "_70-6";
export var imageWrapper = "_70-1";
export var taskList = "_70-a";
export var widget = "_70-0";